import { ISearchQuery } from "../../../shared/hooks/useSearch"
import { AddPathwayToCaseActionTypes, IFetchPathwaysAddableToCaseAsyncAction } from "./addPathwayToCaseTypes"

export const fetchPathwaysAddableToCaseAsync = (searchQuery: ISearchQuery): IFetchPathwaysAddableToCaseAsyncAction => {
  return {
    type: AddPathwayToCaseActionTypes.FETCH_PATHWAYS_ADDABLE_TO_CASE_ASYNC_PENDING,
    payload: searchQuery
  }
}
